module.exports = __webpack_public_path__ + "static/media/unfriend.544e93e0.svg";